import { Button } from '@workspace/core-ts/components';
import { cn, normalizeEuro } from '@workspace/utils';
import { ReactNode } from 'react';

export interface PricingCardProps {
    id: string;
    titre: string;
    description?: string;
    prix?: {
        valeur: number;
        periode: string;
        sous?: string;
        prixOriginal?: number; // Prix avant promo (pour affichage barré)
    };
    selected: boolean;
    recommande?: boolean;
    onSelect: (id: string) => void;
    children?: ReactNode;
    variant?: 'formule' | 'option';
    tarifVariant?: 'amo' | 'mae';
    textes: {
        recommande: string;
        selectionne: string;
        selectionner: string;
    };
}

export const PricingCard = ({
    id,
    titre,
    description,
    prix,
    selected,
    recommande,
    onSelect,
    children,
    variant = 'formule',
    tarifVariant = 'mae',
    textes,
}: PricingCardProps) => (
    <div
        className={cn(
            'relative transition-all cursor-pointer border-2 flex flex-col rounded-lg ',
            selected
                ? 'border-primary bg-primary text-white'
                : 'bg-card border-transparent hover:border-border',
        )}
        onClick={() => onSelect(id)}
    >
        {recommande && (
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10">
                <span
                    className={cn(
                        'px-3 py-1 text-xs font-semibold rounded-lg whitespace-nowrap',
                        tarifVariant === 'amo' ? 'bg-amber-400 text-white' : 'bg-secondary text-primary',
                    )}
                >
                    {textes.recommande}
                </span>
            </div>
        )}
        <div className="p-4 sm:p-6 h-full ">
            <div className="text-center mb-4">
                <h2 className="text-base sm:text-lg mb-1">{titre}</h2>
                {description && <p className="text-xs opacity-60">{description}</p>}
            </div>
            {prix && (
                <div className="text-center mb-4">
                    <div className="flex items-baseline justify-center gap-1">
                        <span className={cn('text-2xl sm:text-3xl font-bold')}>
                            {variant === 'option' && '+'}
                            {normalizeEuro(prix.valeur)}
                        </span>
                        <span className="text-sm opacity-60">/ {prix.periode}</span>
                    </div>
                    {prix.prixOriginal && prix.prixOriginal > prix.valeur && (
                        <div className="text-xs opacity-70 line-through mt-1">
                            {variant === 'option' && '+'}
                            {normalizeEuro(prix.prixOriginal)} / {prix.periode}
                        </div>
                    )}
                    {prix.sous && <p className="text-xs opacity-50 mt-1">{prix.sous}</p>}
                </div>
            )}
            {children}
        </div>
        <div className="px-6 pb-4">
            <Button
                // variant="primary"
                variant={selected ? 'outline' : 'primary'}
                size="sm"
                className="w-full"
                arrow={false}
            >
                {selected ? textes.selectionne : textes.selectionner}
            </Button>
        </div>
    </div>
);
